// @erp/module-audit/fe · the module's typed edge (DEV-GUIDE-002 §6.3 — per-module
// hc client, NOT one giant hc<AppType> everywhere: that anti-pattern crawls the
// editor and defeats tree-shaking, §10). auditApi is hc<AuditRoutes> based at
// /api/audit — the mount point the gateway gives createAuditRouter — so
// `auditApi.trail.$get()` targets `/api/audit/trail` with the portal's
// cookie-riding defaults (credentials:'include', @erp/api-client).
// Mirrors modules/cms/src/fe/client.ts.
//
// `import type` is load-bearing TWICE over:
//   1. Runtime — a VALUE import of '../api' would drag Hono, the repo, the
//      service layer and the tier-1 middleware into the browser bundle.
//      Type-only, it is erased (verbatimModuleSyntax keeps us honest).
//   2. The seam — if a trail route leaves the chained expression in
//      api/router.ts (or a response shape drifts), AuditRoutes changes and THIS
//      build fails typecheck. One source of truth for the wire, at compile time.
import type { AuditRoutes } from "../api/index.js";
import { createApiClient } from "@erp/api-client";

/** The module-scoped hc client. Screens/queries import THIS, never a portal-wide client. */
export const auditApi = createApiClient<AuditRoutes>("/api/audit");
export type AuditApi = typeof auditApi;
